<template>
  <div class="webview flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col xs="12">
          <div class="clearfix">
            <h1 class="web-hidden">1on1naviヘルプ</h1>
            <div role="tablist">
              <b-card v-for="(help, idx) in helps" v-bind:key="'help'+idx" no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle="'help' + idx" variant="info">{{ help.head }}</b-btn>
                </b-card-header>
                <b-collapse :id="'help' + idx" accordion="helpAccordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text" v-html="help.body"></p>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.webview {
  overflow: auto;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
}
h2 {
  font-size: 1.25rem;
}
h3 {
  font-size: 1.15rem;
}
h2 > span {
  margin-left: 1em;
  text-decoration: underline;
}
span.nth {
  margin-right: 0.5em;
}
.card-header .btn {
  white-space: normal;
  text-align: left;
}
</style>

<script>
// import { content1on1 } from '@/main'
export default {
  name: 'WebViewHelpsJA',
  data () {
    return {
      oneContentSet: this.get1on1Contents,
      helps: [
        {
          head: `1on1naviの基本メニュー`,
          body: `
スクリーンの下段に配置されている以下のアイコンが1on1naviのメニューです。<ul class="list-adjusted">
<li>・${this.$t('topTitle')}</li>
<li>・${this.$t('oneOnTitleType')}</li>
<li>・${this.$t('rtfbType')}</li>
<li>・Notice</li>
<li>・Other</li>
</ul>`
        },
        {
          head: `ユーザーを検索する`,
          body: `
スクリーンの下にあるアイコン「Other」をタップして、サブメニューから「People」を選択すると、検索欄と最近チェックしたユーザーのリストが表示されます。<br>
<br>
検索欄にユーザー名またはメールアドレスを入力すると検索結果が表示されます。<br>
該当するユーザー名をタップすると、情報（プロフィール、${this.$t('topTitle')}、${this.$t('oneOnTitleType')}、${this.$t('rtfbType')}）が表示されます。<br>
`
        },
        {
          head: `グループを作成する`,
          body: `
グループを作成することで、${this.$t('topTitle')}、${this.$t('oneOnTitleType')}、${this.$t('rtfbType')}の公開範囲をグループに登録されているユーザーに設定することやグループメンバーの通知を受け取る設定を一括で行うことができます。<br>
<br>
スクリーンの下にあるアイコンの「Other」からサブメニューの「People」をタップし、People検索画面を表示させます。グループタブの右上にあるアイコン「＋」をタップして、グループ名を記入し、「作成」をタップします。<br>
グループ作成画面でメンバーの右にある「＋」を選択して、ユーザーを検索し、追加するユーザーが表示されたら選択します（チェックボックスにチェックがつきます）。<br>
左上のアイコン「＜」をタップするとグループメンバー候補に追加されます。<br>
以上のユーザー検索・選択を繰り返してグループメンバーを選び終わったら、右上のアイコン「完了」ボタンをタップするとグループが作成され、グループ一覧に追加されます。<br>
`
        },
        {
          head: `${this.$t('topTitle')}を確認する`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('topTitle')}」をタップすると、${this.$t('topTitle')}の一覧が表示されます。<br>
<br>
${this.$t('okrDetailType')}について、進捗率、内容、開始日、期限、コメント数、${this.$t('relatedOkrType')}数が表示され、
その下に${this.$t('okrDetailType')}に紐づく${this.$t('keyResultDetailType')}の情報が表示されます。<br>
※コメント数、${this.$t('relatedOkrType')}数の数字がオレンジで太字の場合は未読のコメント、${this.$t('relatedOkrType')}があります。<br>
<br>
${this.$t('topTitle')}の一覧より、詳細を確認したい${this.$t('okrDetailType')}または${this.$t('keyResultDetailType')}を選択すると詳細が確認できます。以下の項目が表示されます。<br><ul class="list-adjusted">
<li>・ユーザー名</li>
<li>・作成日（日時）</li>
<li>・目標 ※文字数が多い場合はハイライト表示されますが、「もっと見る」リンクをタップすることで内容が確認できます。</li>
<li>・開始日</li>
<li>・期限</li>
<li>・公開</li>
<li>・進捗率</li>
<li>・${this.$t('keyResultDetailType')} ※${this.$t('okrDetailType')}の場合のみタブ表示</li>
<li>・コメント</li>
<li>・${this.$t('relatedOkrType')} ※${this.$t('relatedOkrType')}は他のユーザーが関連付けた${this.$t('topTitle')}も表示されます。</li>
</ul>`
        },
        {
          head: `${this.$t('topTitle')}を登録する（${this.$t('okrDetailType')}、${this.$t('keyResultDetailType')}を登録する）`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('topTitle')}」をタップすると${this.$t('topTitle')}の一覧が表示されます。<br>
右上のアイコン「＋」をタップして、「新規作成」または「下書きから作成」をタップすると、${this.$t('okrDetailType')}を登録することができます。<br>
<br>
${this.$t('okrDetailType')}登録画面より、以下の項目を入力・選択します。<ul class="list-adjusted">
<li>・「目標」：${this.$t('okrDetailType')}の内容を、文字入力または音声入力によって登録します。</li>
<li>・「開始日」、「期限」：タップすると「日付入力ダイアログ」から設定することが可能です。特に指定がない場合は、「操作日」となります。</li>
<li>・「公開設定」：右にあるアイコン「＋」をタップして設定することが可能です。特に指定がない場合は、公開範囲は「全員」となります。</li>
<li>・「進捗率」：円形のゲージをドラックすることで設定できます。アイコン「＋」、「－」をタップして数値を変更することも可能です。</li>
<li>・「${this.$t('relatedOkrType')}」：右にあるアイコン「＋」をタップして、ユーザーを検索・選択して、そのユーザーの${this.$t('topTitle')}一覧を表示し、${this.$t('okrDetailType')}または${this.$t('keyResultDetailType')}をタップして、${this.$t('relatedOkrType')}として設定することができます。</li>
</ul>
右上のアイコン「保存」をタップして、「保存」または「下書きとして保存」をタップすることで、登録または下書き保存が完了します。<br>
<br>
${this.$t('okrDetailType')}の登録後、続けて${this.$t('keyResultDetailType')}の登録ができます。<br>
${this.$t('keyResultDetailType')}の登録内容は${this.$t('okrDetailType')}の登録内容と同じです。<br>
<br>
${this.$t('keyResultDetailType')}は${this.$t('okrDetailType')}の登録を完了した後で登録することもできます。${this.$t('topTitle')}の一覧より、該当の${this.$t('okrDetailType')}を選択して${this.$t('okrDetailType')}の詳細にある${this.$t('keyResultDetailType')}タブのアイコン「${this.$t('keyResultDetailType')}を追加」をタップすると${this.$t('keyResultDetailType')}を登録することができます。<br>
`
        },
        {
          head: `${this.$t('relatedOkrType')}として${this.$t('okrDetailType')}（${this.$t('keyResultDetailType')}）を関連付ける`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('topTitle')}」をタップすると、${this.$t('topTitle')}の一覧が表示されます。<br>
<br>
${this.$t('topTitle')}の一覧より関連させたい${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})をタップし、${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})の詳細を表示します。<br>
※事前に${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})を入力しておく必要があります。<br>
<br>
${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})の詳細スクリーンの中ほどにある「${this.$t('relatedOkrType')}」をタップし、スクリーン下部の「${this.$t('relatedOkrType')}を追加」をタップします。<br>
<br>
スクリーン上部の検索欄（虫眼鏡マーク）にて関連させたい${this.$t('topTitle')}を設定しているユーザーを検索し、検索結果に表示されたユーザー、あるいは「最近チェックしたユーザー」（以前に検索したことがあると表示されます）の中から該当者をタップします。<br>
<br>
タップしたユーザーの${this.$t('topTitle')}の一覧より、関連させたい${this.$t('topTitle')}をタップします。<br>
<br>
「確認 ${this.$t('relatedOkrType')}を追加しますか？」ウィンドウが開くので「追加」をタップすると関連付けられます。<br>
<br>
（確認方法)<br>
関連させた${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})の詳細スクリーンの中ほどにある「${this.$t('relatedOkrType')}」をタップし、関連させた${this.$t('topTitle')}が表示されば関連付けがされています。<br>
`
        },
        {
          head: `${this.$t('topTitle')}の進捗率を変更する`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('topTitle')}」をタップすると、${this.$t('topTitle')}の一覧が表示されます。<br>
<br>
${this.$t('topTitle')}の一覧より進捗率を変更させたい${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})をタップし、${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})の詳細を表示します。<br>
※事前に${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})を入力しておく必要があります。<br>
<br>
${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})の詳細スクリーンの中ほどにある「進捗率」の円形のゲージにある〇をスライドさせるか、円グラフの左右にある「－」「＋」をタップすることで「進捗率」を変更できます。<br>
`
        },
        {
          head: `${this.$t('topTitle')}を完了する、完了した${this.$t('topTitle')}を確認する`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('topTitle')}」をタップすると、${this.$t('topTitle')}の一覧が表示されます。<br>
<br>
${this.$t('topTitle')}の一覧より完了させたい${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})をタップし、${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})の詳細を表示します。<br>
※事前に${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})を入力しておく必要があります。<br>
<br>
スクリーン右上の「…」をタップするとウィンドウに「${this.$t('okrDetailType')}（/${this.$t('keyResultDetailType')})編集」「完了にする」、「削除」、「キャンセル」が表示されるので「完了にする」をタップします。<br>
<br>
「確認 ステータスを完了に変更しますか？」ウィンドウが開くので「OK」をタップすると「ご案内 ステータスを完了にしました。」ウィンドウが開くので「OK」をタップすることで完了にできます。<br>
<br>
（完了した${this.$t('topTitle')}を確認する）<br>
＜${this.$t('okrDetailType')}＞<br>
スクリーンの下にあるアイコンの「${this.$t('topTitle')}」をタップすると、${this.$t('topTitle')}の一覧が表示されます。<br>
スクリーンの左上にあるアイコンの「三」をタップする<br>
Menuスクリーンとなるので「完了${this.$t('topTitle')}」をタップします。<br>
完了${this.$t('topTitle')}スクリーンになり、完了した${this.$t('topTitle')}の一覧が確認できます。<br>
<br>
＜${this.$t('keyResultDetailType')}＞<br>
スクリーンの下にあるアイコンの「${this.$t('topTitle')}」をタップすると、${this.$t('topTitle')}の一覧が表示されます。<br>
${this.$t('topTitle')}の一覧より完了を確認したい${this.$t('keyResultDetailType')}の右上にチェックマークがついていれば完了になっています。<br>
`
        },
        {
          head: `${this.$t('topTitle')}の一覧に表示されている${this.$t('okrDetailType')}の並び順を変更する`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('topTitle')}」をタップすると、${this.$t('topTitle')}の一覧が表示されます。<br>
<br>
左上のアイコン「三」をタップし、更に「並び順設定」をタップしてリストを表示させ、${this.$t('okrDetailType')}を並び替えます。 <br>
並び替えは、次のいずれかの項目をタップすることで実施できます。<ul class="list-adjusted">
<li>・登録日時（降順）</li>
<li>・登録日時（昇順）</li>
<li>・更新日時（降順）</li>
<li>・更新日時（昇順）</li>
</ul>`
        },
        {
          head: `${this.$t('oneOnTitleType')}の振り返りを確認する`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('oneOnTitleType')}」を選択すると、実施した${this.$t('oneOnTitleType')}の一覧が最新のものから順に表示されます。<br>
<br>
${this.$t('oneOnTitleType')}の一覧より、詳細を確認したい${this.$t('oneOnTitleType')}を選択し、次の項目をタップすると詳細を確認できます。<ul class="list-adjusted">
<li>・${this.$t('firstContent1on1')}</li>
<li>・${this.$t('secondContent1on1')}</li>
<li>・${this.$t('thirdContent1on1')}<br> ※文字数が多い場合はハイライト表示されますが、「もっと見る」リンクをタップすることで内容が確認できます。<br> また、右上のアイコン「ノートの絵」をタップすると、非公開になっている、次の項目の内容を確認できます。</li>
<li>・${this.$t('memoContent1on1')}</li>
</ul>
`
        },
        {
          head: `${this.$t('oneOnTitleType')}の振り返りを登録する`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('oneOnTitleType')}」を選択すると、実施した${this.$t('oneOnTitleType')}の一覧が表示されます。<br>
<br>
右上のアイコン「＋」をタップして、「新規作成」または「下書きから作成」をタップすると、${this.$t('oneOnTitleType')}の振り返りを登録することができます。<br>
<br>
「日付」は、タップすると「日付入力ダイアログ」から設定することが可能です。特に指定がない場合は、「操作日」となります。<br>
<br>
「相手」は、右にあるアイコン「＋」クリックするとユーザを選択することができ、1on1の相手を設定できます。<br>
<br>
「公開設定」は、右にあるアイコン「＋」をタップして設定することも可能です。特に指定がない場合は、公開範囲は「全員」となります。<br>
<br>
振り返り内容は、次の項目の各欄に、文字入力または音声入力によって登録します。<ul class="list-adjusted">
<li>・${this.$t('firstContent1on1')}</li>
<li>・${this.$t('secondContent1on1')}</li>
<li>・${this.$t('thirdContent1on1')}</li>
<li>・${this.$t('memoContent1on1')}（※上の公開設定に関わらず非公開です。）</li>
</ul>
右上のアイコン「✓」をタップして、「保存」または「下書きとして保存」をタップすることで、登録または下書き保存が完了します。<br>
`
        },
        {
          head: `${this.$t('oneOnTitleType')}リクエストを送信する`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('oneOnTitleType')}」を選択すると、実施した${this.$t('oneOnTitleType')}の一覧が表示されます。<br>
<br>
左上のアイコン「メールマーク」とタップすると、「${this.$t('oneOnTitleType')} Request」が表示されます。<br>
<br>
「送信先」は、右にある「＋」をタップして設定します。<br>
<br>
「コメント」欄に、${this.$t('oneOnTitleType')}リクエストの内容を文字入力または音声入力によって登録します。<br>
<br>
コメント欄下にある「送信」をタップすると、送信先に${this.$t('oneOnTitleType')}リクエストが送信されます。<br>
`
        },
        {
          head: `${this.$t('rtfbType')}をみる`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('rtfbType')}」を選択すると、${this.$t('rtfbType')}の一覧が表示されます。<br>
見たい内容をタップすると該当ページ（${this.$t('rtfbType')} 詳細）に進みます。<br>
※文字数が多い場合はハイライト表示されますが、「もっと見る」リンクをタップすることで内容が確認できます。<br>
`
        },
        {
          head: `${this.$t('rtfbType')}を投稿する`,
          body: `
スクリーンの下にあるアイコンの「${this.$t('rtfbType')}」を選択すると、${this.$t('rtfbType')}の一覧が表示されます。<br>
<br>
右上のアイコン「＋」とタップして、「新規作成」または「下書きから作成」をタップすると、${this.$t('rtfbType')}を登録することができます。<br>
<br>
「公開設定」は、右にあるアイコン「＋」をタップして設定することも可能です。特に指定がない場合は、公開範囲は「全員」となります。<br>
<br>
${this.$t('rtfbType')}の内容を記入欄に、文字入力または音声入力によって登録します。<br>
アイコンの「クリップ」をタップするとコメントに画像の貼付ができます。<br>
<br>
右上のアイコン「✓」をタップして、「保存」または「下書きとして保存」をタップすることで、登録または下書き保存が完了します。<br>
`
        },
        {
          head: `コメントを投稿する`,
          body: `
${this.$t('topTitle')}、${this.$t('oneOnTitleType')}、${this.$t('rtfbType')}の詳細より、コメントをしたい掲載内容の左下にあるCommentタブをタップすると、スクリーンの一番下に「Comment」と表示された長方形の枠が表示されます。枠の中にコメントを入力してから「送信」ボタンを押します。<br>
アイコンの「クリップ」をタップすることでコメントに画像の貼付ができます。<br>
`
        },
        {
          head: `「いいね」をつける`,
          body: `
${this.$t('rtfbType')}に対して「いいね」をつけたい場合は、${this.$t('rtfbType')}一覧の掲載内容の下にあるグレーの☆マークをタップします。または該当する${this.$t('rtfbType')}をタップして詳細スクリーンを表示し、${this.$t('rtfbType')}内容の下にあるグレーの☆マークをタップすることでも「いいね」をつけることができます。☆が黄色になれば自分が「いいね」しています。${this.$t('rtfbType')}詳細の「いいね」タブから「いいね」をつけたユーザーの一覧が確認できます。<br>
<br>
${this.$t('topTitle')}、${this.$t('oneOnTitleType')}、${this.$t('rtfbType')}のコメントに対して「いいね」を行う場合は、「いいね」をしたいコメントの下にあるグレーの☆マークをタップします。☆が黄色になれば自分が「いいね」しています。「いいね」の数字をタップすると「いいね」をつけたユーザーの一覧が確認できます。<br>
`
        },
        {
          head: `通知をみる`,
          body: `
スクリーンの下にあるアイコンの「Notice」の横に赤い数字がでていれば、未読のお知らせがあります。<br>
<br>
通知詳細を見るには、「Notice」をタップすると一覧が表示されます。通知対象となった${this.$t('topTitle')}、${this.$t('oneOnTitleType')}、${this.$t('rtfbType')}などの詳細情報を見たい場合は一覧から選んでタップすると該当ページに進みます。<br>
`
        },
        {
          head: `他ユーザーの通知を受け取れるようにする`,
          body: `
スクリーンの下にあるアイコンの「Notice」をタップし、左上の「歯車」のマークを選び、設定したいユーザー、グループをタップします。<br>
<br>
「通知を受け取りますか？」というメッセージが表示されますので、「受け取る」をタップすると通知を受け取ることが可能になります。<br>
設定したユーザーのアクションについて以下のような通知を受け取ることができます。<ul class="list-adjusted">
<li>・${this.$t('topTitle')}の作成・更新・削除</li>
<li>・${this.$t('oneOnTitleType')}の作成・更新・削除</li>
<li>・${this.$t('rtfbType')}の作成・更新・削除</li>
</ul>`
        },
        {
          head: `他ユーザーのアクションに応じた通知を受け取るように設定する`,
          body: `基本メニューにある「Notice」を選択、その後、左上の人物マークを選択して右上の歯車マークを押すと、
          アクション（作成、更新、削除など）の一覧が表示されます。アクションの右側にあるチェックボックスを選択して、
          通知を設定し、右上の「✔」マークを選択すると、アクション別の通知の受け取りが可能になります。<br>
`
        },
        {
          head: `${this.$t('oneOnTitleType')}リクエストの受信を確認する`,
          body: `
スクリーンの下にあるアイコンの「Notice」をタップし、右上の「メール」マークをタップします。<br>
<br>
${this.$t('oneOnTitleType')}Request受信履歴が表示されますので、見たいメッセージをタップし、詳細（送信元とコメント）を確認します。<br>
`
        },
        {
          head: `プロフィールを編集する`,
          body: `
スクリーンの下にあるアイコンの「Other」からサブメニュー「Profile」をタップします。<br>
右上の「ペン」マークをタップし、編集したい項目をタップし入力します。（※メールアドレスは変更不可）<br>
入力が完了したら、右上の「✓」マークをタップし、保存します。<br>
`
        },
        {
          head: `コンディションを変更する`,
          body: `
スクリーンの下にあるアイコンの「Other」からサブメニュー「Profile」をタップします。右上にある「ペン」マークから編集できるようにして、コンディション（お天気のマーク）を選択して「✓」マークをタップして変更できます。<br>
その他、スクリーンの下のメニュー${this.$t('topTitle')}から${this.$t('topTitle')}一覧ヘッダー部に表示されているお天気マークを直接タップしてコンディションのリストから選んで変更することもできます。<br>
`
        },
        {
          head: `ログアウトする`,
          body: `
スクリーンの下のメニュー「${this.$t('topTitle')}」を選択し、左上のアイコン「三」をタップすると、一覧メニューに「ログアウト」が表示されるので、タップすると、ログアウトしてログイン画面へ移ります。<br>
`
        }
      ]
      // content1on1: content1on1,
      // contentTitle: {
      //   0: '・' + this.$t('firstContent1on1'),
      //   1: '・' + this.$t('secondContent1on1'),
      //   2: '・' + this.$t('thirdContent1on1'),
      //   3: '・' + this.$t('forthContent1on1')
      // }
    }
  },
  computed: {
    // checkContent1on1 () {
    //   return Object.keys(content1on1.content1on1).length
    // },
    // get1on1Contents () {
    //   let oneContentArray = []
    //   console.log('this.checkContent1on1', this.checkContent1on1)
    //   for (let i = 0; i < this.checkContent1on1; i++) {
    //     console.log('count::::', i, this.contentTitle[i])
    //     oneContentArray.push(this.contentTitle[i])
    //   }
    //   console.log('oneContentArray:::::', oneContentArray)
    //   let resultContent = oneContentArray.join(',')
    //   console.log('resultContent:::::', resultContent)
    //   return resultContent
    // }
  }
}
</script>
<style scoped>
.web-hidden {
  display: none;
}
.p-1 {
  padding: 0.5rem !important;
  transition: 0.2s all;
}
.card-header .btn {
  margin-top: 0;
}
.btn-info {
  background-color: #ffffff;
  border-color: #fcfcfc;
  padding: 0.8rem 1rem;
}
.btn-info:hover,
.btn-info:focus,
.btn-info.focus {
  color: #fff;
  background-color: #39b2d5;
  box-shadow: none;
}
.mb-1,
.my-1 {
  margin-bottom: 0.5rem !important;
}
.card-body,
.card-block {
  padding: 1.5rem 1.8rem;
}
</style>



// WEBPACK FOOTER //
// src/views/_webview/WebViewHelpsJA.vue